import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

interface LButtonCloseProps {
  onClick?: () => void;
  size?: "small" | "medium" | "large";
  color?: "black" | "danger" | "primary" | "white" | "gray";
}

const LButtonClose: React.FC<LButtonCloseProps> = ({
  onClick,
  size = "medium",
  color = "danger",
}) => {
  let buttonClass = "12px";

  switch (size) {
    case "small":
      buttonClass = "12px";
      break;
    case "medium":
      buttonClass = "15px";
      break;
    case "large":
      buttonClass = "18px";
      break;
    default:
      break;
  }

  return (
    <button
      type="button"
      className={"btn-close position-relative"}
      style={{ fontSize: `${buttonClass}` }}
      onClick={onClick}
      aria-label="Close"
    >
      <i className={`zmdi zmdi-close text-${color}`} />
    </button>
  );
};

export default LButtonClose;
